import axios from "axios";

export const AUTH_TOKEN_KEY = "IZI_AUTH_TOKEN";
export const BASE_URL = "https://izichange.com";
const DASHBOARD_URL="https://dashboard.izichange.com"
const language_code='react'

// export const BASE_URL = "https://changely.click";

export const isMobile = function () {
    let check = false;
    (function (a) { if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true; })(navigator.userAgent || navigator.vendor || window.opera);
    return check;
}

/**
 * Determine the mobile operating system.
 * This function returns one of 'iOS', 'Android', 'Windows Phone', or 'unknown'.
 *
 * @returns {String}
 */
export function getMobileOperatingSystem() {
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;

    // Windows Phone must come first because its UA also contains "Android"
    if (/windows phone/i.test(userAgent)) {
        return "Windows Phone";
    }

    if (/android/i.test(userAgent)) {
        return "Android";
    }

    // iOS detection from: http://stackoverflow.com/a/9039885/177710
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        return "iOS";
    }

    return "unknown";
}

export const getMobileDownloadLink = (type) => {
    if (isMobile()) {
        switch (type ?? getMobileOperatingSystem()) {

            case 'iOS': {
                return "https://apps.apple.com/bj/app/izichange/id1613924189"
            }
            case 'Android': {
                return "https://play.google.com/store/apps/details?id=com.izichange"
            }
            default: {
                return "https://play.google.com/store/apps/details?id=com.izichange"
            }
        }
    }
    return false
}

export function setCookie(cname, cvalue, exdays = 1) {
    const d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    let expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

export function getCookie(cname, cookies = null) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(cookies ?? document.cookie);
    let ca = decodedCookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return null;
}

export function deleteCookie(cname) {
    document.cookie = `${cname}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
}



export const extractToken = (token) => {
    const base64Url = token.split(".")[1];
    const base64 = base64Url?.replace(/-/g, "+").replace(/_/g, "/");
    if (!base64) return null;
    const jsonPayload = decodeURIComponent(
        atob(base64)
            .split("")
            .map(function (c) {
                return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
            })
            .join("")
    );
    return JSON.parse(jsonPayload);
}

export const hasTokenExpired = (token) => {

    const jsonPayload = extractToken(token)
    const { exp } = jsonPayload;
    return Date.now() >= exp * 1000

}

export function redirectToSecure(uri, lang = "fr", checkLogin = true, newWindow = true, token = null,email=null) {


    const auth_token = token ?? getCookie(AUTH_TOKEN_KEY)
    if (Boolean(auth_token)) {
        sendPOSTSyncRequest(uri, auth_token, lang, newWindow,email);
    } else {
        window.open("/login", '_self');
    }
}
export async function isConnected(lang){
    const auth_token = getCookie(AUTH_TOKEN_KEY) 
    if (Boolean(auth_token)) {
        sendPOSTSyncRequest(BASE_URL+"/dashboard/pu_echange", auth_token, lang,false)
        return true
    } else  return false
}

// export function verifConnexion() {
//     const auth_token = getCookie(AUTH_TOKEN_KEY);
//     if(Boolean(auth_token)) 
// }

let sendPOSTSyncRequest = (uri, access_token, lang = "fr", newWindow = true,email=null) => {
    const formTag = document.createElement("form");
    formTag.enctype = "application/x-www-form-urlencoded"
    formTag.method = 'POST'
    formTag.lang = lang
    formTag.target = newWindow ? '_blank' : '_self'
    formTag.action = BASE_URL+'/secure/pu_startEchange/web'
    if(language_code == 'react'){
        // window.location = `${DASHBOARD_URL}/echange?token=${access_token}&lang=${lang}`;
        return
    }
    formTag.innerHTML = `<input type='hidden' name='method' value='${BASE_URL}/${uri}'/>
        <input type='hidden' name='x-http-lang' value='${lang}'/>
        <input type='hidden' name='email' value='${email}'/>
        <input type='hidden' name='x-http-authorization' value='Bearer ${access_token}'/>
        <input type='hidden' name='x-http-appversion' value='2.0.1'/>`
    document.body.appendChild(formTag);
    formTag.submit();

}


let sendSyncRequestXML = (uri, access_token) => {
    const request = new XMLHttpRequest();
    const token = "Bearer " + access_token
    request.open("POST", BASE_URL+"/secure/pu_startEchange/web", false);
    request.setRequestHeader("Authorization", token)
    request.setRequestHeader("Content-Type", "application/json")
    request.setRequestHeader("appversion", "2.0.1")
    request.send(JSON.stringify({
        method: `${BASE_URL}/${uri}`
    })); 
}

export const csrfTokenCheck = (token) =>{
    const [signature, timestamp] = token.split('.'); 
    if ((Date.now() / 1000 - parseInt(timestamp, 10)) < 14400) {
        return true; // Token is valid and not expired
    } else {
        return false; // Token is invalid or expired
    }
}

export const login = async (email, password,csrf, googleCaptchaToken, lang) => {

    if(!csrfTokenCheck(csrf)){
        if (typeof window !== 'undefined' && !window.navigator.userAgent.includes('ReactSnap')) {
            // window.location.href = BASE_URL + "?expired_token"
        }
        return
    }

    const params = new URLSearchParams();
    params.append('email', email);
    params.append("password", password);
    params.append("csrf_token", csrf);
    params.append("token", googleCaptchaToken);

    const options = {
        Accept: 'application/json',
        method: 'POST',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'lang': lang,
            'appversion': "2.0.1"
        },
        data: params,
        withCredentials: true, // Include cookies in the request
        url: BASE_URL+"/api/pu_auth/web" 
    };


    return axios(options)
}
export const a2fFunc = async (code, token,lang) => {
    const params = new URLSearchParams();
    params.append('code', code); 
    params.append('token', token);

    const options = {
        Accept: 'application/json',
        method: 'POST',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'lang': lang,
            'appversion': "2.0.1"
        },
        data: params,
        url: BASE_URL+"/api/pu_verification_code"
    };


    return axios(options)
}


